import './styles/_main.scss'
import Header from './components/Header'
import Hero from './components/Hero'
import Services from './components/Services'
import Footer from './components/Footer'

function App() {
  return (
    <>
      <Header />
      <Hero />
      <Services />
      <Footer />
    </>
  )
}

export default App
